<template>
    <div>
        <div class="baiseback" :style="'min-height: 100vh;'+(webW?'':'padding-top:70px;')">


            <div slot="header" class="tishi">
                <span><i class="el-icon-search"></i>&nbsp;搜索</span>

            </div>
            <div style="text-align: center;">
 
                <p  @click="sel='searchUser'">
                    <router-link to="SearchUser?indexSearchType=searchUser" class="caidan"> 搜用户</router-link>
                </p>
                <p  @click="sel='searchForum'">
                    <router-link to="SearchForum?indexSearchType=searchForum" class="caidan">搜帖子</router-link>
                </p>

            </div>
        </div>

    </div>


</template>

<script>


    import {getWindowWidth} from "../../../api/common";

    export default {
        name: 'SerachLeft',
        data() {
            return {
                sel: 'searchUser',
                webW:true,

            }
        },
        methods: {},

        mounted() {
            this.webW = getWindowWidth() >= 1000 ? true : false;
            this.lander = JSON.parse(this.$store.state.logininfo);

            if (this.$route.query.indexSearchType != undefined) {
                this.sel = this.$route.query.indexSearchType;
            }
        }, watch: {
            $route: function (value) {
                if (value.query.indexSearchType != undefined) {
                    this.sel = value.query.indexSearchType;
                }


            }
        },
        activated() {


        },
        deactivated() {

        }
    };
</script>

<style scoped>

</style>
